import React from 'react'
import CustomPagination from '../pagination'

export default function InvalidPageDetails({
  totalLength,
  setMinValue,
  setMaxValue,
  defaultPageSize = 5,
  defaultCurrent = 1,
}) {
  return (
    <div>
      <CustomPagination
        defaultPageSize={defaultPageSize}
        setMaxValue={setMaxValue}
        setMinValue={setMinValue}
        totalLength={totalLength}
        defaultCurrent={defaultCurrent}
      />
    </div>
  )
}
